import { io } from "socket.io-client";
import Config from "./Config";
import { getCookie } from "./Utils";

// One Socket.IO connection for the entire admin app's lifetime, held in a
// module-scope variable rather than component state/ref - this is what
// makes it survive React re-renders, route changes, and StrictMode's
// deliberate double-invoke of effects in development without ever opening
// a second real connection. Components never construct a socket themselves;
// they call getSocket()/connectSocket()/disconnectSocket() below.
let socketInstance = null;

const buildSocket = () => io(Config.URL.BACKEND_URL, {
    autoConnect: false,
    transports: ["websocket", "polling"],
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
    // `auth` as a function (not a plain object) is re-invoked by
    // socket.io-client on every (re)connection attempt, so a token that
    // changed between disconnect and reconnect - or simply wasn't set yet
    // the first time this module loaded - is always read fresh rather than
    // captured once and gone stale.
    auth: (callback) => callback({
        token: getCookie("token"),
        page: window.location?.pathname || "",
    }),
});

export const getSocket = () => {
    if (!socketInstance) socketInstance = buildSocket();
    return socketInstance;
};

export const connectSocket = () => {
    const socket = getSocket();
    if (!socket.connected) socket.connect();
    return socket;
};

export const disconnectSocket = () => {
    if (!socketInstance) return;
    if (socketInstance.connected) {
        try {
            socketInstance.emit("admin:offline");
        } catch (error) {
            // best-effort - the transport-level disconnect below is what the
            // backend actually relies on to mark this admin offline
        }
    }
    socketInstance.disconnect();
};
